import script from "./DottedRow.vue?vue&type=script&setup=true&lang=js"
export * from "./DottedRow.vue?vue&type=script&setup=true&lang=js"

import "./DottedRow.vue?vue&type=style&index=0&id=7ca10b48&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ca10b48"]])

export default __exports__